import { render } from "./DocumentsHitachi.vue?vue&type=template&id=2492876d&scoped=true"
import script from "./DocumentsHitachi.vue?vue&type=script&lang=js"
export * from "./DocumentsHitachi.vue?vue&type=script&lang=js"

import "./DocumentsHitachi.vue?vue&type=style&index=0&id=2492876d&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2492876d"]])

export default __exports__